import { useAtomValue } from 'jotai';
import { Fragment } from 'react';

import { sequencesWithValuesAtom } from '@/features/equipment-browser/equipment-details/state/sequencer-editor.state';

import { CondenserSequencerEditor } from './condenser-sequencer-editor';
import { CondenserSequencerInstructionsContent } from './condenser-sequencer-instructions-content';
import { SequencerInstructions } from '../components/sequencer-instructions';

export const CondenserSequencerEditorV1 = () => {
  const sequenceWithValues = useAtomValue(sequencesWithValuesAtom).at(0);
  if (!sequenceWithValues) {
    return null;
  }
  return (
    <Fragment key="condenser-sequencer-editor-v1">
      <CondenserSequencerEditor isActive={true} sequenceWithValues={sequenceWithValues} />
      <SequencerInstructions id="condenser">
        <CondenserSequencerInstructionsContent />
      </SequencerInstructions>
    </Fragment>
  );
};
